import { useMutation } from '@tanstack/react-query'
import { downloadDistributionReport } from './requests'

type UseDownloadDistributionReportOptions = {
  onSuccess?: (blob: Blob, distributionId: number) => void
  onError?: (error: Error) => void
}

export const useDownloadDistributionReport = (
  options?: UseDownloadDistributionReportOptions
) => {
  return useMutation({
    mutationFn: downloadDistributionReport,
    onSuccess: (blob, variables) => {
      options?.onSuccess?.(blob, variables.distributionId)
    },
    onError: (error: Error) => {
      options?.onError?.(error)
    },
  })
}
